import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.5 22 .5-.5 1.58-1.58c2.773-2.773 4.159-4.159 4.678-5.757a7 7 0 0 0 0-4.326c-.52-1.598-1.905-2.984-4.678-5.757L16.5 3l-.5-.5M11.5 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm5.474-2.525-2.6-2.6c-.691-.692-1.037-1.038-1.44-1.286a3.998 3.998 0 0 0-1.157-.478C11.317 3 10.827 3 9.849 3H8.9c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2.5 6.04 2.5 7.16 2.5 9.4v.949c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.441l2.6 2.6c1.584 1.585 2.376 2.377 3.289 2.673a4 4 0 0 0 2.472 0c.913-.296 1.705-1.088 3.29-2.672l.948-.95c1.585-1.584 2.377-2.376 2.673-3.289a4 4 0 0 0 0-2.472c-.296-.913-1.088-1.705-2.672-3.29Z"
    />
  </svg>
)
export default SvgComponent
